import React, {useState} from 'react';
import {gql} from '@apollo/client';
import {useMutation, useQuery} from '@apollo/client/react';
import {Button, Stack} from '@mui/material';
import {useParams} from 'react-router';

import CardFrame from '../common/CardFrame';
import InputFile from '../common/InputFile';
import {Loader} from '../common/General';

const GET_EVENT_COMPETITOR = gql`
  query GetEventCompetitors($slug: String!) {
    allEventCompetitors(slug: $slug) {
      name
      siCard
    }
  }
`;

const UPLOAD_RESULTS_SI_DATA = gql`
  mutation UploadResultsSiData($slug: String!, $file: Upload!) {
    uploadResultsSiData(slug: $slug, file: $file)
  }
`;

const ImportSiDataPage = () => {
  const {eventSlug} = useParams();
  const [isSelectedFile, setIsSelectedFile] = useState(false);
  const [xmlFile, setXmlFile] = useState<File | undefined>();

  const {loading} = useQuery(GET_EVENT_COMPETITOR, {
    variables: {
      slug: eventSlug
    }
  });

  const [uploadResultsSiData] = useMutation<{uploadResultsSiData: boolean}>(UPLOAD_RESULTS_SI_DATA);

  if (loading) return <Loader />;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension === 'xml') {
        setXmlFile(file);
        setIsSelectedFile(true);
      }
    }
  };

  const handleSubmit = async () => {
    const {data} = await uploadResultsSiData({
      variables: {
        slug: eventSlug,
        file: xmlFile
      }
    });
    if (data?.uploadResultsSiData) {
      console.log('Done');
    }
  };

  return (
    <div className="container-fluid">
      <CardFrame title="Import SI Data">
        {!isSelectedFile && <InputFile onFileSelect={handleFileChange} label="Select File" />}
        {isSelectedFile && (
          <Stack direction="row" spacing={1}>
            <Button variant="contained" onClick={handleSubmit}>
              Save
            </Button>
          </Stack>
        )}
      </CardFrame>
    </div>
  );
};

export default ImportSiDataPage;
